import React from 'react';
import { authRoles } from 'app/auth';

export const CostReportsConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	// Only super admins can access cost research
	auth: authRoles.admin,
	routes: [
		{
			path: '/cost-reports/:id',
			component: React.lazy(() => import('./CostReportDetail'))
		},
		{
			path: '/cost-reports',
			component: React.lazy(() => import('./CostReports'))
		}
	]
};
